<section class="header-inner text-white mt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row pgb ">
                    <div class="col step p-0" [ngClass]="{'active': currentStep === 1, 'complete': (currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5)}">
                        <div>
                            <a [routerLink]="" (click)="onStepClicked(1)" class="anchor">
                                <span class="img-circle">1</span>
                            </a>
                        </div>
                        <div>
                            <p>Task</p>
                        </div>
                    </div>

                    <div class="col step p-0" [ngClass]="{'active': currentStep === 2, 'complete': currentStep === 3 || currentStep === 4 || currentStep === 5 }">
                        <div>
                            <a [routerLink]="" (click)="onStepClicked(2)" class="anchor">
                                <span class="img-circle">2</span>
                            </a>
                        </div>
                        <div>
                            <p>Talents</p>
                        </div>
                    </div>

                    <div class="col step p-0" [ngClass]="{'active': currentStep === 3, 'complete': currentStep === 4 || currentStep === 5}">
                        <div>
                            <a [routerLink]="" (click)="onStepClicked(3)" class="anchor">
                                <span class="img-circle">3</span>
                            </a>
                        </div>
                        <div>
                            <p>Discuss</p>
                        </div>
                    </div>

                    <div class="col step p-0" [ngClass]="{'active': currentStep === 4, 'complete': currentStep === 5}">
                        <div>
                            <a [routerLink]="" (click)="onStepClicked(4)" class="anchor">
                                <span class="img-circle">4</span>
                            </a>
                        </div>
                        <p>Hire</p>
                    </div>

                    <div class="col step p-0" [ngClass]="{'active': currentStep === 5, 'complete': currentStep === 6}">
                        <div>
                            <a [routerLink]="" (click)="onStepClicked(5)" class="anchor">
                                <span class="img-circle">5</span>
                            </a>
                        </div>
                        <p>Close</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>